import dayjs from 'dayjs';

export const dayJsTz = (timezone: string, date?: dayjs.ConfigType) => {
  return dayjs(date || new Date()).tz(timezone);
};
